import styled from '@emotion/styled';
import KizenTypography from 'app/kizentypo';

export const TrackingWarning = styled(KizenTypography)`
  font-style: italic;
  margin-bottom: 15px;
  color: var(--color-font-placeholder);
`;
export const TrackingWrapper = styled.div`
  margin-top: -5px;
  margin-bottom: 20px;
`;
